import { FC } from "react";

import './Footer.scss';

export const Footer: FC = () => (
    <div className="footer">
        <div className="container">
            <div className="footer__copyright">© ЧОО Штык, 2025</div>
        </div>
    </div>
)